interface PageHeaderProps {
  title: string
  description?: React.ReactNode
  actions?: React.ReactNode
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actions
}) => (
  <header className="flex min-h-16 shrink-0 items-center gap-4 border-b border-gray-200 px-7 py-2.5">
    <div className="flex flex-col space-y-0.5">
      <h1 className="font-roobert text-base font-medium leading-6 text-neutral-900">
        {title}
      </h1>
      {description ? (
        <p className="font-roobert text-sm font-normal leading-5 text-neutral-600">
          {description}
        </p>
      ) : null}
    </div>
    {actions ? (
      <div className="ml-auto flex items-center gap-3">{actions}</div>
    ) : null}
  </header>
)
